import { useEffect, useMemo, useState } from 'react'
import type { ExchangeRate } from '@/services/exchange/types'
import { company } from '@/config/company'
import { formatRate } from '@/utils/formatRate'
import styles from './FxConverter.module.css'

interface FxConverterProps {
  rates: ExchangeRate[]
}

export function FxConverter({ rates }: FxConverterProps) {
  const fxRates = useMemo(() => rates.filter((r) => r.category === 'fx'), [rates])
  const [amount, setAmount] = useState('0')
  const [code, setCode] = useState('USD')

  useEffect(() => {
    const first = fxRates[0]
    if (!first) return
    if (!fxRates.some((r) => r.code === code)) {
      setCode(first.code)
    }
  }, [fxRates, code])

  const selected = fxRates.find((r) => r.code === code)
  const parsed = Number(String(amount).replace(',', '.')) || 0
  const buyTotal = selected ? parsed * selected.buy : 0
  const sellTotal = selected ? parsed * selected.sell : 0

  return (
    <section className={styles.section} aria-labelledby="converter-title">
      <div className="container">
        <div className={styles.card}>
          <h3 id="converter-title">Döviz Çevirici</h3>
          <p className={styles.legal}>{company.legalName}</p>

          <div className={styles.fields}>
            <label className={styles.field}>
              <span>Miktar</span>
              <input
                type="number"
                min="0"
                step="0.01"
                inputMode="decimal"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </label>

            <label className={styles.field}>
              <span>Para Birimi</span>
              <select value={code} onChange={(e) => setCode(e.target.value)}>
                {fxRates.map((r) => (
                  <option key={r.sourceCode} value={r.code}>
                    {r.code}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className={styles.totals}>
            <div>
              <span>TOPLAM ALIŞ/BUY</span>
              <strong>
                {formatRate(buyTotal)} <small>TRY</small>
              </strong>
            </div>
            <div>
              <span>TOPLAM SATIŞ/SELL</span>
              <strong>
                {formatRate(sellTotal)} <small>TRY</small>
              </strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
